export default __webpack_public_path__ + "static/media/005-close eyes.2d34f45f.svg";